import { useState, useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
// helpers
import { useAccessPermission } from "@/helpers/acessPermission";

// UI
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import InfoItem from "@/components/InfoItem";

// Icons
import { Pen } from "lucide-react";

// Services and Types
import type { LandAssetList } from "@/types/soe";
import formatDate from "@/utils/formatDate";

export const Route = createFileRoute(
  "/_layout-private/account-management/soe/_information/land/$detailId"
)({
  component: LandDetail,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      data: search.data as string | undefined,
    };
  },
});

function LandDetail() {
  const { data } = Route.useSearch();
  const navigate = useNavigate();
  const params = Route.useParams();
  const { company_management } = useAccessPermission();
  const [parseData, setParseData] = useState({} as LandAssetList);

  // Effects
  useEffect(() => {
    if (data) {
      console.log(JSON.parse(data), "Data");
      setParseData(JSON.parse(data));
    }
  }, [data]);

  console.log("Params", params);

  return (
    <div className="space-y-[32px]">
      <div className="text-[18px]">
        <h2 className="font-bold text-zinc-950">ຂໍ້ມູນທີ່ດິນ</h2>
        <p className="text-zinc-500">ລາຍລະອຽດຂໍ້ມູນທີ່ດິນຂອງວິສາຫະກິດ</p>

        <Separator className="my-6" />
      </div>

      <div className="flex justify-end w-full">
        {company_management.isUpdate && (
          <Button
            onClick={() =>
              navigate({
                to: "/account-management/soe/land/mutate",

                search: {
                  id: params.detailId,
                  data: data,
                },
              })
            }
          >
            <Pen className="mr-2" />
            ແກ້ໄຂ
          </Button>
        )}
      </div>

      <div className="space-y-[12px] w-full">
        <InfoItem label="ປີ:" value={parseData?.yearly} />
        <InfoItem label="ເນື້ອໃນທີ່ດິນ:" value={parseData?.title} />
        <InfoItem label="ປະເພດທີ່ດິນ:" value={parseData?.landType} />
        <InfoItem
          label="ເນື້ອທີ່ທັງໝົດ (ມ2/ຮດ):"
          value={parseData?.totalArea}
        />
        <InfoItem label="ທີ່ຕັ້ງຂອງດິນ:" value={parseData?.location} />
        <InfoItem
          label="ທຶນໃນການຈັດຊື້:"
          value={parseData?.landFundType?.name}
        />
        <InfoItem
          label="ມູນຄ່າເບື້ອງຕົ້ນ:"
          value={parseData?.initialValue?.toLocaleString()}
        />
        <InfoItem
          label="ມູນຄ່າໃນປະຈຸບັນ:"
          value={parseData?.currentValue?.toLocaleString()}
        />
        <InfoItem label="ການນຳໃຊ້ທີ່ດິນ:" value={parseData?.usage} />
      </div>

      <div className="text-[18px]">
        <h2 className="font-bold text-zinc-950">ຂໍ້ມູນທີ່ດິນ</h2>
        <p className="text-zinc-500">ລາຍລະອຽດຂໍ້ມູນທີ່ດິນຂອງວິສາຫະກິດ</p>

        <Separator className="my-6" />
      </div>

      <div className="space-y-[12px] w-full">
        <InfoItem
          label="ວັນທີສ້າງ:"
          value={formatDate({
            date: parseData?.createdAt,
            format: "DD/MM/YYYY",
          })}
        />
        <InfoItem label="ສ້າງໂດຍ:" value={parseData?.createdBy || "-"} />
        <InfoItem
          label="ອັບເດດລ່າສຸດ:"
          value={formatDate({
            date: parseData?.updatedAt,
            format: "DD/MM/YYYY",
          })}
        />
        <InfoItem label="ອັບເດດໂດຍ:" value={parseData?.updatedBy || "-"} />
      </div>
    </div>
  );
}
